import { useMutation } from "@tanstack/react-query";
import { Favorites } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import i18n from "i18n";
const putFavoriteItem = async (grn) => Favorites.addItemToFavorites(grn);
const deleteFavoriteItem = (grn) => Favorites.removeItemFromFavorites(grn);
const useFavoriteItemMutation = () => {
  const putMutation = useMutation({
    mutationFn: putFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("use_favorite_item_mutation_notifications.put_failed", { ns: "common", error: errorThrown }),
        i18n.t("use_favorite_item_mutation_notifications.put_failed_title", { ns: "common" })
      );
    }
  });
  const deleteMutation = useMutation({
    mutationFn: deleteFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("use_favorite_item_mutation_notifications.delete_failed", { ns: "common", error: errorThrown }),
        i18n.t("use_favorite_item_mutation_notifications.delete_failed_title", { ns: "common" })
      );
    }
  });
  return { putItem: putMutation.mutateAsync, deleteItem: deleteMutation.mutateAsync };
};
export default useFavoriteItemMutation;
